import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgBase, colorBgPrimaryLight, colorTextMedium, space1, space2, space4, space5, space6, space8, space12 } =
    theme();

  return StyleSheet.create({
    bottomMessage: {
      marginBottom: space8,
      marginTop: space8,
    },
    centeredContainer: {
      alignItems: "center",
      justifyContent: "center",
    },
    container: {
      alignItems: "center",
      flexDirection: "column",
      flexGrow: 1,
      justifyContent: "center",
      width: "100%",
    },
    crossSellingBanner: {
      flex: 1,
    },
    footer: {
      bottom: space4,
      right: space4,
    },
    looksWrapperDesktop: {
      alignItems: "center",
      paddingTop: space8,
    },
    looksWrapperMobile: {
      flex: 1,
      paddingHorizontal: space4,
      paddingTop: space4,
    },
    mainContentContainer: {
      backgroundColor: colorBgPrimaryLight,
    },
    subtitle: {
      color: colorTextMedium,
      marginBottom: space4,
    },
    subtitleDesktop: {
      textAlign: "center",
    },
    titleDesktop: {
      marginBottom: space2,
      textAlign: "center",
    },
    titleMobile: {
      marginBottom: space1,
    },
    titleWrapperDesktop: {
      backgroundColor: colorBgPrimaryLight,
      paddingBottom: space8,
      paddingTop: space12,
    },
    titleWrapperMobile: {
      backgroundColor: colorBgBase,
      marginBottom: space4,
      paddingHorizontal: space6,
      paddingVertical: space5,
    },
  });
};

export { style };
